export enum NotificationType {
    EMAIL = 'EMAIL',
    SMS = 'SMS',
    PHONE = 'PHONE',
    WEB = 'WEB',
}
